import React from 'react'
import styled from '@emotion/styled';
import DetailMain from '../../components/organisms/lineupDetail/detailMain';
import ProductTitle from '../../components/atoms/lineupDetail/propductTitle';
import StimulationLevel from '../../components/atoms/stimulationLevel';
import LabelGroup from '../../components/molecules/labelGroup';
import DetailMainHead from '../../components/molecules/lineupDetail/detailMainHead';
import DetailMainBody from '../../components/molecules/lineupDetail/detailMainBody';
import CategoryGroup from '../../components/molecules/lineupDetail/categoryGroup';
import Br from '../../components/atoms/br';
import DetailTexts from '../../components/molecules/lineupDetail/detailTexts';
import data from '../../assets/data/products.json';
import BtnBlank from '../../components/atoms/btnBlank';
import DetailBtns from '../../components/molecules/lineupDetail/detailBtns';
import DetailFeature from '../../components/organisms/lineupDetail/detailFeature';
import ContentWidth from '../../components/organisms/contentWidth';
import DetailFeatureBox from '../../components/molecules/lineupDetail/detailFeatureBox';
import BottomBtns from '../../components/molecules/lineupDetail/bottomBtns';
import SectionLineup from '../../components/organisms/sectionLineup';
import StoreBtnGroup from '../../components/molecules/storeBtnGroup';
import StoreBtn from '../../components/atoms/storeBtn';
import DetailFeatureItem from '../../components/molecules/lineupDetail/detailFeatureItem';
import Caption from '../../components/atoms/caption';
import { Helmet } from 'react-helmet';

const filteredData = data.filter((item, index) => {
  if(item.name === 'モンダミン ナイトクリア') return true;
});

const isNoStoreBtns = (filteredData[0].amazonUrl === "") && (filteredData[0].lohacoUrl === "") && (filteredData[0].rakutenUrl === "");

const Container = styled.div`
`
const MondahminNightclear = () => {
  return(
    <Container>
      <Helmet
        title="モンダミン ナイトクリア | ラインナップ | モンダミン| アース製薬"
        meta={[
            { name: 'description', content: "おやすみ前にすすぐだけ。殺菌成分が効果的にお口に留まり、寝ている間の菌の増殖を抑え、口内トラブルを防ぐ。モンダミン ナイトクリアについてご紹介します。" },
            { name: 'keywords', content: "モンダミンナイトクリア,洗口液,マウスウォッシュ,口臭,口臭ケア,むし歯,歯肉炎,オーラルケア,アース製薬" }
        ]}
      />
      <ContentWidth>
        <DetailMain imgPath={'lineup/mondahmin-nightclear/img-main.png'}>
          <DetailMainHead>
            <ProductTitle>{filteredData[0].name}</ProductTitle>
            <LabelGroup labels={filteredData[0].label}></LabelGroup>
            <StimulationLevel level={'3.5'}></StimulationLevel>
            <CategoryGroup categories={[<>口臭・汚れ<Br />ネバつき予防</>, <>歯肉炎予防</>, '殺菌', <>アルコール<Br onlyPc />配合</>]}></CategoryGroup>
            <DetailTexts title={filteredData[0].description}>
              おやすみ前にすすぐだけ。殺菌成分が効果的にお口に留まり、翌朝の口臭、ネバツキを防ぐ。<Br />さっぱりとしたプレミアムハーブの香味。
            </DetailTexts>
          </DetailMainHead>
          <DetailMainBody>
            <dl>
              <dt>効果・効能：</dt>
              <dd>口臭予防 / 歯垢付着予防 / 歯肉炎予防 / 口中浄化 / 口中爽快</dd>
            </dl>
            <dl>
              <dt>サイズ：</dt>
              <dd>1080mL</dd>
            </dl>
          </DetailMainBody>
          <DetailBtns isNoStoreBtns={isNoStoreBtns}>
            {!isNoStoreBtns &&
              <StoreBtnGroup>
                <StoreBtn store={'amazon'} href={filteredData[0].amazonUrl}></StoreBtn>
                <StoreBtn store={'rakuten'} href={filteredData[0].rakutenUrl}></StoreBtn>
                <StoreBtn store={'lohaco'} href={filteredData[0].lohacoUrl}></StoreBtn>
              </StoreBtnGroup>
            }
            <BtnBlank href={filteredData[0].productInfo}>製品情報サイトへ</BtnBlank>
          </DetailBtns>
        </DetailMain>
        <DetailFeature>
          <DetailFeatureItem>
            <DetailFeatureBox title={<>殺菌成分CPC<sup>＊1</sup>で長時間殺菌コート</>} img={'lineup/feature/img-feature-05.png'} alt={'殺菌成分CPCで長時間殺菌コート'}>
              ・殺菌成分CPC<sup>＊1</sup>が効果的にお口に留まるから、おやすみ前にすすぐだけで、寝ている間の菌の増殖を抑え、口内トラブルを防ぐ。
              <Caption>＊1 CPC：セチルピリジニウム塩化物水和物</Caption>
            </DetailFeatureBox>
            <DetailFeatureBox title={'口臭や歯肉炎の原因となる歯垢の付着を抑制'}></DetailFeatureBox>
            <DetailFeatureBox title={<>抗炎症成分GK<sub>2</sub><sup>＊2</sup>配合で、歯肉炎を予防</>}>
              <Caption>＊2 GK<sub>2</sub>：グリチルリチン酸ジカリウム</Caption>
            </DetailFeatureBox>
          </DetailFeatureItem>
        </DetailFeature>
        <BottomBtns productInfo={filteredData[0].productInfo}></BottomBtns>
      </ContentWidth>
      <SectionLineup></SectionLineup>
    </Container>
  );
}
export default MondahminNightclear
